var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-search-container"},[_c('CContainer',[_c('CCategoryNew',{attrs:{"title":_vm.title,"root-category-id":_vm.rootCategoryId},on:{"suggestion-select":_vm.handleCategoryChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }